import(/* webpackMode: "eager" */ "/app/src/app/(web)/error.tsx");
